 <div class="card mt-3">


<div *ngIf="orderRestrictions" >
<div class="alert alert-success" *ngIf="orderRestrictions?.min_order_rest_active == '1'">
    {{orderRestrictions?.min_order_rest_description}}
</div>
</div>
    <table class="table table-striped table-condensed" width="100%"
           *ngIf="this.cart != null && this.cart.items !=null && this.cart.items.length >0 " class="cart-panel">
        <tr>
            <th width="80"></th>
            <th width="200" i18n>Item</th>
            <th i18n>Item Price</th>
            <th i18n>Qty</th>

            <th i18n>Subtotal</th>

            <th></th>
        </tr>
        <tr *ngFor="let item of this.cart.items">

            <td><img class="item-img" *ngIf="item.product ==null" src="assets/gray.png" width="80" height="80"/>
                <img class="item-img"  *ngIf="item.product !=null" width="80" height="80"
                     src="{{this.baseImageUrl}}/{{item.product.media_gallery_entries[0].file}}"/>
            </td>
            <td >
                <div style="    font-size: 11px;">{{item.name}}</div>

            </td>
            <td>
                <div style=" ">{{current_currency}} {{(item.price * rate) | number: this.registry.getSettingByID('price_format')}}</div>
            </td>
            <td width="150">
                <!--                <input type="text" class="qty" size="20" value="{{item.qty}}"/>-->
                <app-numeric-updown qty="{{item.qty}}" [item]="item" [cart]="cart"></app-numeric-updown>
            </td>

            <td >
                <div style="font-weight: bold;">{{current_currency}} {{ updateQTY(item.price * rate , item.qty)}} </div>
            </td>
            <td  class="text-center">
                <i *ngIf="isDeletingItem != item.item_id" class="fa fa-trash" (click)="removeCartItem(item)"></i>
                <img *ngIf="isDeletingItem == item.item_id" src="assets/loader.gif" width="40" height="40" />
            </td>

        </tr>
    </table>
    <div class="alert alert-info" *ngIf="this.cart == null || this.cart.items.length == 0 " i18n="@@noItemInCart">
        <i class="la la-shopping-cart" ></i> There are currently no items in your cart.
    </div>


</div>
